import { atom } from "recoil";
import { campaignStageProps } from "../pages/Campaigns/NewCampaign";
import { format } from 'date-fns';


export interface CreateCampaignProps {
  currentStage: campaignStageProps;
  data: {
    campaign_name: string;
    list_uid: string;
    sms_sender_uid: string;
    email_sender_uid: string;
    whatsapp_sender_uid: string;
    message_body: string;
    email: string;
    subject: string;
    template_uid: string;
    timezone: string | undefined;
    send_date: Date | string;
    channel: string;
    builder: string;
    builder_content:string;
    sender_number: string;
    sms_body: string;
    link_uid: string;
    save_and_exit: boolean;
    route: string;
    send_type: string;
  };
  newCampaignId: string;
}


const createCampaignAtom = atom<CreateCampaignProps>({
  key: "createCampaignAtom_",
  default: {
    currentStage: "Getting Started",
    data: {
      campaign_name: "",
      list_uid: "",
      sms_sender_uid: "",
      email_sender_uid: "",
      whatsapp_sender_uid: "",
      message_body: "<p>Hello {{first_name}},</p>",
      email: "",
      subject: "",
      template_uid: "",
      timezone: undefined,
      send_date: "",
      channel: "",
      builder: "",
      builder_content:"",
      sender_number: "",
      sms_body: "",
      link_uid: "",
      save_and_exit: false,
      route: "",
      send_type: "",
    },
    newCampaignId: "",
  },
});

export { createCampaignAtom };
